<script>
    import CourseTypeCourses from '/public/components/courses/CourseTypeCourses.svelte';

    export let currentRoute;
    
    let course_type_id = currentRoute.namedParams.courseTypeID;    

</script>

<p class='text-end'>
    <a href='/home' class='btn btn-outline-secondary'>
        <span class='fas fa-chevron-left'></span> All Courses
    </a>
</p>

<CourseTypeCourses    
    course_type_id={course_type_id}
/>